const MODULE = {

  state: {
    organizations: [],
    clientOrganizationInfo: [],

    // for users page
    userList: [],
    queryMatches: 0
  },

  mutations: {
    setOrganizations (state, organizations) {
      state.organizations = organizations
    },

    addOrganization (state, organization) {
      state.organizations.push(organization)
    },

    setClientOrganizationInfo (state, clientOrganizationInfo) {
      state.clientOrganizationInfo = clientOrganizationInfo
    },

    setUserList (state, userList) {
      state.userList = userList
    },

    setQueryMatches (state, queryMatches) {
      state.queryMatches = queryMatches
    }
  },

  actions: {
    requestAllOrganizations: async (context) => {
      // gets and sets all organizations for the activated challenge
      const endpoint = '/api/v1/organization'

      const organizationsResponse = await context.dispatch('authorizedFetch', {
        method: 'GET',
        endpoint: endpoint
      }, { root: true })

      context.commit('setOrganizations', organizationsResponse.organizations)
    },

    requestOrganization: async (context, uuid) => {
      const orgEndpoint = `/api/v1/organization/${uuid}`

      var orgResponse = await context.dispatch('authorizedFetch', {
        method: 'get',
        endpoint: orgEndpoint
      })

      if (orgResponse.success !== false) {
        return orgResponse.organization
      }
    },

    requestClientOrganizationInfo: async (context) => {
    //   // TODO this may need to be rethought but return the organization that this user is associated with

    //   context.commit('setClientOrganizationInfo', organizationInfo)
    },

    // user info
    requestScrollUsers: async (context, { size, page, organization, name, email }) => {
      // TODO find a user based on name and email (pagination enabled)

      // const userList = []
      // for (const user of userSearchResponse.users) {
      //   const organization = await context.dispatch('requestOrganization', user.organization)
      //   user.organization = organization.name
      //   userList.push(user)
      // }

      // context.commit('setUserList', userList)
      // context.commit('setQueryMatches', userSearchResponse.matches)
    }
  }
}

export default MODULE
